import styled, { css } from 'styled-components'

import { SYSTEM_FONT } from 'styles/theme/typography'

// Icons
import { ReactComponent as ChevronsUpDownIcon } from 'icons/chevrons-up-down-16.svg'

const invalidStyles = css`
  border: 2px solid ${({ theme }) => theme.colors.state.negative};
`

export const NativeSelectWrapper = styled.div`
  position: relative;
`

export const StyledChevronsUpDownIcon = styled(ChevronsUpDownIcon)`
  width: 6px;
  height: 10px;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.colors.foreground.secondary[4]};
  z-index: ${({ theme }) => theme.zIndex[1]};
`

export const baseSelectStyles = css<{ invalid?: boolean; arrowIcon?: any }>`
  position: relative;
  width: 100%;
  display: block;

  user-select: none;
  appearance: none;
  -webkit-tap-highlight-color: transparent;

  padding: 10px 0 10px 12px; /* stylelint-disable-line scales/space */
  font-size: ${({ theme }) => theme.fontSizes.small};
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};

  border: 1px solid ${({ theme }) => theme.colors.border[2]};
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 ${({ theme }) => theme.colors.shadow.inner} inset;

  background-color: ${({ theme }) => theme.colors.background.secondary[2]};

  &:disabled,
  &[aria-disabled='true'] {
    color: ${({ theme }) => theme.colors.foreground.secondary[4]};
  }

  ${({ invalid }) => invalid && `${invalidStyles}`};

  /* native select */
  &[data-invalid='true'],
  /* data-reach-listbox */
  [data-invalid='true'] & {
    ${invalidStyles};
  }

  &:focus {
    background: ${({ theme }) => theme.colors.background.secondary[1]};

    ${({ invalid }) =>
      invalid &&
      css`
        ${invalidStyles};
      `};
  }
`

const NativeSelect = styled.select`
  ${baseSelectStyles};

  /**
   * We are forcing the default system font only for Safari.
   * Safari uses a serif font when it doesn't find Marfa. By using an apple font, we ensure that dropdown
   * items are similar to the rest of the page.
   * See https://gist.github.com/jbutko/6718701#gistcomment-2630350
   */
  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) {
      font-family: ${SYSTEM_FONT};
    }
  }
`

export default NativeSelect
